/**
 * @generated SignedSource<<997d891c6de820bbb2bcfebb9d80b8ce>>
 * @relayHash 760113b4d7a9d899532af7823cd6a3cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterProductEntityType = "COMMON_REQUEST_TYPES" | "JSM_HELP_OBJECTS" | "KNOWLEDGE_CARDS" | "%future added value";
export type HelpCenterUpdateInput = {
  helpCenterAri: string;
  helpCenterBranding?: HelpCenterBrandingInput | null | undefined;
  homePageLayout?: HelpCenterHomePageLayoutInput | null | undefined;
  name?: HelpCenterNameInput | null | undefined;
  productEntityImages?: ReadonlyArray<HelpCenterProductEntityImageInput> | null | undefined;
  slug?: string | null | undefined;
  virtualAgentEnabled?: boolean | null | undefined;
};
export type HelpCenterBrandingInput = {
  banner?: HelpCenterBannerInput | null | undefined;
  colors?: HelpCenterBrandingColorsInput | null | undefined;
  homePageTitle?: HelpCenterHomePageTitleInput | null | undefined;
  logo?: HelpCenterLogoInput | null | undefined;
};
export type HelpCenterBannerInput = {
  filedId?: string | null | undefined;
  useDefaultBanner?: boolean | null | undefined;
};
export type HelpCenterBrandingColorsInput = {
  bannerTextColor?: string | null | undefined;
  primary?: string | null | undefined;
  topBarColor?: string | null | undefined;
  topBarTextColor?: string | null | undefined;
};
export type HelpCenterHomePageTitleInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null | undefined> | null | undefined;
};
export type HelpCenterTranslationInput = {
  locale: string;
  localeDisplayName?: string | null | undefined;
  value: string;
};
export type HelpCenterLogoInput = {
  fileId?: string | null | undefined;
};
export type HelpCenterHomePageLayoutInput = {
  layoutAdf?: string | null | undefined;
  metadata?: string | null | undefined;
};
export type HelpCenterNameInput = {
  default: string;
  translations?: ReadonlyArray<HelpCenterTranslationInput | null | undefined> | null | undefined;
};
export type HelpCenterProductEntityImageInput = {
  entityId: string;
  entityType: HelpCenterProductEntityType;
  fileId?: string | null | undefined;
  imageUrl?: string | null | undefined;
};
export type useHelpCenterUpdateMutation$variables = {
  cloudId: string;
  input: HelpCenterUpdateInput;
};
export type useHelpCenterUpdateMutation$data = {
  readonly helpCenter: {
    readonly updateHelpCenter: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useHelpCenterUpdateMutation = {
  response: useHelpCenterUpdateMutation$data;
  variables: useHelpCenterUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHelpCenterUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHelpCenterUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenter",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d3d3262d636a27920e26696c66036437dcba90e372b1abb8f496dcb471b17f68",
    "metadata": {},
    "name": "useHelpCenterUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "162638a77ba5d44dfe258f5e31598716";

export default node;
